export const LANDING = {
  // Nav
  navLogo: "nav-logo",
  navChatgpt: "nav-chatgpt",
  navClaude: "nav-claude",
  navFree: "nav-free",

  // Hero
  heroHeadline: "hero-headline",
  heroCtaChatgpt: "hero-cta-chatgpt",
  heroCtaClaude: "hero-cta-claude",
  heroCtaGemini: "hero-cta-gemini",
  heroCypherStage: "hero-cypher-stage",
  heroCypherImg: "hero-cypher-img",

  // Featured challenges
  challengesGrid: "challenges-grid",
  challengeCard: (slug) => `challenge-card-${slug}`,
  challengeCta: (slug) => `challenge-cta-${slug}`,

  // Comparison
  comparisonSection: "comparison-section",
  comparisonChatgpt: "comparison-chatgpt",
  comparisonClaude: "comparison-claude",
  comparisonGemini: "comparison-gemini",
  comparisonCopilot: "comparison-copilot",
  comparisonExecutive: "comparison-executive",

  // Free resources / lead form (preserved)
  emailCaptureForm: "email-capture-form",
  inputName: "input-name",
  inputEmail: "input-email",
  submitGuideButton: "submit-guide-button",
  downloadAgainButton: "download-again-button",
  resetFormButton: "reset-form-button",
  successUpsellButton: "success-upsell-button",

  // Why JK Academy
  whyList: "why-list",
  whyItem: (i) => `why-item-${i}`,
  whyCypher: "why-cypher",

  // Cypher callouts
  cypherCallout: "cypher-callout",

  // Coming soon (legacy) + AI QuickStart Library
  comingSoonGrid: "coming-soon-grid",
  comingSoonCard: (slug) => `coming-soon-card-${slug}`,
  librarySection: "library-section",
  libraryAvailableGrid: "library-available-grid",
  libraryUpcomingGrid: "library-upcoming-grid",
  libraryCard: (slug) => `library-card-${slug}`,

  // Bundle
  bundleTeaser: "bundle-teaser",
  bundleCta: "bundle-cta",

  // Instructor
  instructorSection: "instructor-section",

  // Footer
  footerChatgpt: "footer-chatgpt",
  footerClaude: "footer-claude",
  footerGemini: "footer-gemini",
  footerPerplexity: "footer-perplexity",
  footerNotebooklm: "footer-notebooklm",
  footerCopilot: "footer-copilot",
  footerFreeGuide: "footer-free-guide",
  footerTwentyDay: "footer-twenty-day",
  footerMastery: "footer-mastery",
};
